export class Service {
  id: string;
  type: string;
  description: string;
  options: string[];
  photos: any[];
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/models/service.ts